import AccountPaper from '@/components/Account/AccountPaper'
import { Button } from '@evocolabs/orkaui'
import React from 'react'
import { Typography } from '@mui/material'
import i18n from 'i18next'
import k from '../../../../i18n/keys'
import { styled } from '@mui/material/styles'

const PREFIX = 'NoOrderMobile'

const classes = {
  containerLayout: `${PREFIX}-containerLayout`,
  accountPaperLayout: `${PREFIX}-accountPaperLayout`,
  textLayout: `${PREFIX}-textLayout`,
  textStyle: `${PREFIX}-textStyle`,
  styleButton: `${PREFIX}-styleButton`
}

const Root = styled('div')(({ theme }) => {
  return {
    [`& .${classes.containerLayout}`]: {
      minHeight: '100vh',
      backgroundColor: '#F2F2F2'
    },

    [`&.${classes.accountPaperLayout}`]: {
      margin: '36px auto',
      height: '85vh'
    },

    [`& .${classes.textLayout}`]: {
      padding: '62px 8vw',
      textAlign: 'center'
    },

    [`& .${classes.textStyle}`]: {
      fontWeight: 500,
      fontSize: 20
    },

    [`& .${classes.styleButton}`]: {
      marginTop: 64,
      width: '240px',
      padding: '6px 12px'
    }
  }
})

function NoOrderMobile() {
  window.scrollTo(0, 0)
  return (
    <Root className={classes.accountPaperLayout}>
      <AccountPaper className={classes.textLayout}>
        <Typography className={classes.textStyle}>
          {i18n.t(k.YOU_HAVEN_T_PLACED_ANY_ORDERS)}
        </Typography>
        <Button
          color="primary"
          variant="contained"
          className={classes.styleButton}
          handleClick={() => {
            window.location.href = '/Product/buy-orka-two'
          }}
        >
          {i18n.t(k.GO_SHOPPING)}
        </Button>
      </AccountPaper>
    </Root>
  )
}

export default NoOrderMobile
